//interfaces
import { IBasicBreadcrumb, ISimpleTableContent } from "thrive-components";

export enum CombinedFeedSortType {
    DateCreatedNewest = 1,
    DateCreatedOldest = 2,
    DateModifiedNewest = 3,
    DateModifiedOldest = 4,
    TitleAZ = 5,
    TitleZA = 6,
}

export enum modeType {
    "all" = "all", 
    "selected" = "selected",
    "none" = "none"
}

export enum feedSourceStatus {
    "none" = "none",
    "default" = "default",
    "full" = "full"
}

export interface IUseCombinedFeed {
    defaultSort?:string;
    children:React.ReactNode
}

export interface ISourceListSelector {
    searchString: string,
    setSearchString: (searchString: string)=>void,
    textInputDisabled: boolean,
    breadCrumbs: IBasicBreadcrumb[],
    modalTable: any,
    showBackButton: boolean,
    onBackButtonClick: ()=>void,
    onCloseClick: ()=>void,
}

export interface ISourceListSelectorTable {
    simpleTableContent: ISimpleTableContent, 
    getMoreContent: any, 
    isLoading: boolean, 
    isInfiniteScroll: boolean,
    infiniteScrollFetchCondition: boolean, 
    noDataMessage: string
};

export interface IFeedSourceParent {
    contentFeedSourceListStatus : feedSourceStatus;
    id: number
    level: number
    title: string
}

export interface IFeedSources {
    contentFeedSourceListStatus: feedSourceStatus;
    parents: IFeedSourceParent[];
}

export interface ISourceListItem {
    id: number;
    title: string;
    type: string;
    featuredImageUrl: string | null;
    groupCount: number;
    groupUserCount: number;
    status: 'draft' | 'published' | 'archived';
    permission: 'view' | 'edit' | 'admin';
    parentIdAndTitles: {
        id: number;
        title: string;
    }[];
    everyoneHasAccess: boolean;
    scheduledPublishDate: string | null;
    scheduledArchiveDate: string | null;
    feedSourceListStatus?: feedSourceStatus;
    feedSources: IFeedSources[];
}

export interface ISourceListsTable {
    simpleTableContent: ISimpleTableContent, 
    getMoreContent:any, 
    isLoading: boolean, 
    isInfiniteScroll: boolean, 
    infiniteScrollFetchCondition: boolean, 
    noDataMessage: string, 
    hideActionsColumn: boolean
};

export interface ISourceListPaginatedResponse {
    total: number,
    modeType: modeType,
	records:ISourceListItem[],
	top: number,
	skip: number,
    moreAvailable: boolean
}
